import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
    const [profiles, setProfiles] = useState([]);

    // Function to fetch profiles from the API
    const fetchProfiles = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/profiles`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProfiles(response.data.profiles);
        } catch (error) {
            console.error('Error fetching profiles:', error);
        }
    };

    // Fetch profiles when the component mounts
    useEffect(() => {
        fetchProfiles();
    }, []);

    return (
        <ProfileContext.Provider value={{ profiles, fetchProfiles }}>
            {children}
        </ProfileContext.Provider>
    );
};

// Custom hook to use the ProfileContext
export const useProfiles = () => {
    return useContext(ProfileContext);
};
